/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `PROVIDER` - Provider
 * * `REVIEWER` - Reviewer
 * * `AUDITOR` - Auditor
 * * `ADMIN` - Admin
 * * `UNAUTHORIZED` - Unauthorized
 * @export
 */
export const NameEnum = {
  provider: 'PROVIDER',
  reviewer: 'REVIEWER',
  auditor: 'AUDITOR',
  admin: 'ADMIN',
  unauthorized: 'UNAUTHORIZED',
} as const;
export type NameEnum = (typeof NameEnum)[keyof typeof NameEnum];

export function instanceOfNameEnum(value: any): boolean {
  for (const key in NameEnum) {
    if (Object.prototype.hasOwnProperty.call(NameEnum, key)) {
      if ((NameEnum as Record<string, NameEnum>)[key] === value) {
        return true;
      }
    }
  }
  return false;
}

export function NameEnumFromJSON(json: any): NameEnum {
  return NameEnumFromJSONTyped(json, false);
}

export function NameEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): NameEnum {
  return json as NameEnum;
}

export function NameEnumToJSON(value?: NameEnum | null): any {
  return value as any;
}
